import { getContext, hasContext, setContext } from 'svelte';
import type { StickerShopMeta } from '$lib/types/StickerShopMeta';

const StickerShopContextKey = Symbol('StickerShopContext');

const defaultValues: StickerShopMeta = {
  figureTags: [],
  stickerShopLogo: undefined,
  stickerShopUrls: undefined,
};

export const setStickerShopContext = (stickerShopMeta: Partial<StickerShopMeta>) => {
  const defaultedContext = { ...defaultValues, ...stickerShopMeta };
  setContext<StickerShopMeta>(StickerShopContextKey, defaultedContext);
};

export const getStickerShopContext = (): StickerShopMeta => {
  if (!hasContext(StickerShopContextKey)) {
    return defaultValues;
  }

  return getContext<StickerShopMeta>(StickerShopContextKey);
};
